/* eslint-disable */
import { Button } from '@mui/material';

export const getBeneficiaryColumns = ({ params, isMobile, handleTransferClick, setSelectedRow, setModalState }) => [
    {
        header: 'Sl. No',
        render: (row, index) => (params.page - 1) * params.limit + index + 1
    },
    {
        header: 'Beneficiary Name',
        align: 'right',
        render: (row) => `${row?.beneNamePrefix || ''} ${row?.beneficiaryFirstName || ''} ${row?.beneficiaryLastName || ''}`.trim()
    },
    {
        header: 'IFSC',
        align: 'right',
        key: 'ifscCode'
    },
    {
        header: 'Account Number',
        align: 'right',
        key: 'accountNumber'
    },
    {
        header: 'Mobile Number',
        align: 'right',
        key: 'mobileNumber'
    },
    {
        header: 'Transfer',
        align: 'center',
        render: (row) => (
            <Button color="primary" variant="contained" size={isMobile ? 'small' : 'medium'} onClick={() => handleTransferClick(row)}>
                Transfer
            </Button>
        )
    },
    {
        header: 'Delete',
        align: 'center',
        render: (row) => (
            <Button
                color="error"
                variant="contained"
                size={isMobile ? 'small' : 'medium'}
                onClick={() => {
                    setSelectedRow(row);
                    setModalState((prev) => ({ ...prev, openDeleteDialog: true }));
                }}
            >
                Delete
            </Button>
        )
    }
];
